export default {
    title: 'Ιστορικό / Οικονομικά',
    panelTitle: 'Συνεδρίες & Οικονομικά',
    balance: 'Υπόλοιπο',
    futureTab: 'Μελλοντικές',
    pastTab: 'Ολοκληρωμένες',
    owedTab: 'Οφειλές',
    remainders: 'Υπόλοιπα',
    noRemainders: 'Κανένα ανοιχτό υπόλοιπο.',
    created: 'Ημ. δημιουργίας',
    showMore: 'Περισσότερα ({count})',
    markUnpaid: 'Δεν πληρώθηκε',
    closedRemainders: 'Κλεισμένα υπόλοιπα',
    session: 'Συνεδρία',
    markPaid: 'Πληρώθηκε',
    recordPayment: 'Έγινε πληρωμή',
    settle: 'Τακτοποίηση',
    deleteEntry: 'Διαγραφή',
    reopen: 'Επαναφορά',
    undoPayment: 'Αναίρεση',
    addRemainder: 'Νέο υπόλοιπο',
    amountLabel: 'Ποσό (€)',
    notesPlaceholder: 'Σημειώσεις (προαιρετικό)',
    submitRemainder: 'Καταχώρηση',
    paymentRecorded: 'Καταγράφηκε η πληρωμή',
    remainderNotice: 'Θα δημιουργηθεί υπόλοιπο {amount} €',
    methods: {
        cash: 'Μετρητά',
        card: 'Κάρτα',
        transfer: 'Έμβασμα',
    },
}
